import React from 'react';

const SvgTag = (props) => (
  <svg width={13} height={11} {...props}>
    <g fill="currentColor" fillRule="evenodd">
      <path
        fill="#1C2B38"
        fillRule="nonzero"
        d="M8.532 0L3.48 5.283a1.387 1.387 0 0 0-.384.966c0 .366.137.71.384.968l2.616 2.735a1.27 1.27 0 0 0 1.851 0L13 4.67V0H8.532zM5.177.19L.363 5.222A1.314 1.314 0 0 0 0 6.137c0 .346.129.67.363.915l3.32 3.472.875-.915-3.32-3.472 4.815-5.034L5.177.19zm3.868 1.104h2.717v2.84L7.07 9.037h-.1L4.353 6.303v-.105l4.691-4.904zm.86 1.294a.634.634 0 0 0-.62.647c0 .358.278.647.62.647.342 0 .619-.29.619-.647a.634.634 0 0 0-.62-.647z"
      />
    </g>
  </svg>
);

export default SvgTag;
